import * as React from "react";
import { Props } from "../../types/global";
import t from "../i18n";

declare type ThreeDSecureProps = Props<{transactionId: number, url: string}>;
export default class ThreeDSecure extends React.Component<ThreeDSecureProps> {
    frame = React.createRef<HTMLIFrameElement>();
    componentDidMount() {
        if (this.props.match.params.transactionId) {
            //@ts-ignore
            window[`ok-${this.props.match.params.transactionId}`] = this.props.ok;
        }
        // if (this.frame.current) {
        //     let html = "<html><head></head><body>Hello, <b>"+ "Ajay" +"</b>."
        //     html += "How are you today?</body></html>"
        //     this.frame.current.contentDocument!.write(html);
        // }
    }
    componentWillUnmount() {
        if (this.props.match.params.transactionId) {
            //@ts-ignore
            window[`ok-${this.props.match.params.transactionId}`] = undefined;
        }
    }
    render() {
        const {url} = this.props.match.params;
        // console.log(this.props.match, this.props.match.params.url);
        return <div className="d-flex flex-column" style={{height: "100vh"}}>
            <div>
                <button className="btn btn-primary" onClick={e => this.props.cancel!()}>{t.common("cancel_button")}</button>
            </div>
            <div className="d-flex flex-fill flex-column">
                <iframe ref={this.frame} className="flex-fill w-100" src={url} />
            </div>
        </div>
    }
}